import { InjectionToken } from "@angular/core";
import { RequirementAttachmentsPort } from "./requirement-attachments.port";

export const REQUIREMENT_ATTACHMENTS_PORT = new InjectionToken<RequirementAttachmentsPort>("REQUIREMENT_ATTACHMENTS_PORT");
